const inputFilesLabelNew = {
  text: 'Attach files here'
};

export default inputFilesLabelNew;
